import React, { useContext } from 'react';
import Skyflow from 'skyflow-js';
import sdkVersion from '../../package.json';
export const skyflowContext = React.createContext(undefined);
const useSkyflow = () => {
    const skyflow = useContext(skyflowContext);
    return { skyflow };
};
const useSkyflowInit = (context) => {
    localStorage.setItem('sdk_version', `${sdkVersion.name}@${sdkVersion.version}`);
    const skyflow = Skyflow.init(Object.assign({}, context));
    return skyflow;
};
export { useSkyflow, useSkyflowInit };
//# sourceMappingURL=hook.js.map